import React from 'react';
import LiveProgramsListingPage from './LiveProgramsListingPage';
export default function LiveMentorshipPage() { return <LiveProgramsListingPage type="mentorship"/>; }
